import axios from "axios";
import {utilityServicesPath} from "../../Constants";

export default class UtilityPromotionService {
    static getFormData(selectedFile) {
        const formData = new FormData();
        formData.append("file", selectedFile);
        return formData;
    }

    static async getPage() {
        return axios.get(`${utilityServicesPath}/user/promotion/page`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
    static async getById(id) {
        return axios.get(`${utilityServicesPath}/user/promotion/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getThemeUser() {
        return axios.get(`${utilityServicesPath}/user/theme-promotion`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async getFilter(themeNewsId, page) {
        return axios.get(`${utilityServicesPath}/user/promotion/filter?themeNewsId=${themeNewsId}&page=${page}&pageSize=5`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async get(pageNumber, pageSize, search, themeId, isRelevant, isPopular) {
        const params = {
            page: pageNumber,
            pageSize: pageSize,
            search: search,
            themePromotionId: themeId,
            isRelevant: isRelevant,
            isPopular: isPopular
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return axios.get(`${utilityServicesPath}/admin/promotion/filter?${queryString}`);
    }

    static async add(data, file, themeId) {
        const params = {
            text: data?.text,
            description: data?.description,
            themePromotionId: themeId,
            priorityRelevant: data?.priorityRelevant,
            priorityPopular: data?.priorityPopular,
        };

        const queryString = Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join('&');

        return await axios.post(`${utilityServicesPath}/admin/promotion?${queryString}`, UtilityPromotionService.getFormData(file));
    }

    static async update(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/promotion/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        return await axios.delete(`${utilityServicesPath}/admin/promotion/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }

    static async getTheme() {
        return axios.get(`${utilityServicesPath}/admin/theme-promotion`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async addTheme(data) {
        return await axios.post(`${utilityServicesPath}/admin/theme-promotion`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async updateTheme(data, id) {
        return await axios.put(`${utilityServicesPath}/admin/theme-promotion/${id}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async deleteTheme(id) {
        return await axios.delete(`${utilityServicesPath}/admin/theme-promotion/${id}`, {
            headers: {
                "Content-Type": "multipart/form-data",
            }
        });
    }
}